import React from 'react';
import { graphql } from 'gatsby';

import Seo from 'components/container/Seo';
import PageBuilder from 'components/container/PageBuilder';

export default function TemplateContentPages({ data, pageContext }) {
  const url = pageContext?.url;
  const { backgroundImage } = data;
  const {
    title,
    seoTitle,
    seoDescription,
    seoImage,
    pageBuilderNeo,
  } = data?.craft?.entry;

  return (
    <>
      <Seo
        title={seoTitle || title}
        description={seoDescription}
        url={url}
        image={seoImage?.[0]?.socialMediaUrl}
      />
      <div>
        <PageBuilder
          components={pageBuilderNeo}
          backgroundImage={backgroundImage}
        />
      </div>
    </>
  );
}

export const query = graphql`
  query QueryContentPages($id: [Int]!, $siteId: Int) {
    craft {
      entry(id: $id, siteId: $siteId) {
        id
        title
        slug
        ... on Craft_ContentPages {
          seoTitle
          seoDescription
          seoImage {
            socialMediaUrl: url(transform: transformSocialMedia)
          }
          pageBuilderNeo {
            ...PageBuilderQuery
          }
        }
      }
    }
    backgroundImage: file(relativePath: { eq: "bg-2.jpg" }) {
      ...imageDefault
    }
  }
`;
